import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Link as Linkelement, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import VideoBlock from '../components/VideoBlock';
import SliderBlock from '../components/SliderBlock';


const MessePage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.MessePageData.edges[0]
  return (
    <Layout>
      <Helmet>
        <script defer src="https://use.fontawesome.com/releases/v5.3.1/js/all.js"></script>
      </Helmet>



      <div className=" nav-wrapper">
        <nav className="navbar slide">
          <Linkelement to="top" offset={-150} smooth={true} duration={500} className="presono-logo">
            <img src={withPrefix('/img/logo.svg')} alt="Presono Header Logo" />
          </Linkelement>
          <ul className="messe-nav">
            <li><Linkelement to="node1" offset={-150} smooth={true} duration={500}>Möglichkeiten</Linkelement></li>
            <li><Linkelement to="node2" offset={-150} smooth={true} duration={500}>Optionen</Linkelement></li>
            <li><Linkelement to="node3" offset={-150} smooth={true} duration={500}>Ablauf</Linkelement></li>
            <li><Linkelement to="node4" offset={-150} smooth={true} duration={500}>Kontakt</Linkelement></li>
          </ul>
        </nav>
      </div>



      <section className="solutions sub apps messe">

        <section className="headliner starfield t2 b1 pusher">
          <div className="container">
            <div className="column">
              <Element name="top" />
              <h1>Beeindruckende Präsentationen<br /> für Ihren <strong>Messeauftritt</strong></h1>
              <p>
                einfach, professionell, modern.
              </p>
            </div>
          </div>
        </section>
        <section className="customers alt2">
          <div className="container">
            <div className="special-container">
              <div className="columns">
                <div className="column is-full">
                  <SliderBlock />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="container special-bg">
          <Element name="node1" />
          <div className="columns">
            <div className="column is-full">
              <div className="card">
                <div className="card-content">
                  <div class="columns">
                    <div class="column is-half">
                      <div className="media">
                        <div className="media-content">
                          <div className="messe-headliner">
                            <p>
                            Sie möchten auf Ihrem Messestand <strong>interaktiv und multimedial präsentieren</strong>? Sie möchten Inhalte <strong>selbst warten und verwalten</strong>? Sie möchten nicht mehr auf kostenintensive Individuallösungen von Digital-Agenturen setzen? Kurz gesagt: Sie wollen eine <strong>überzeugende Präsentationslösung für Ihre Messeauftritte</strong>, die einfach mehr kann?
                            </p>
                            <br/>
                            <p>
                            Dann ist presono DAS Tool für Ihren nächsten Messe-Einsatz: Egal ob für <strong>Screen-Bespielungen</strong>, als <strong>interaktive App auf Touchscreens</strong> oder als <strong>Tablet-Lösung</strong> für das Team am Messestand - presono passt sich Ihren individuellen Bedürfnissen an.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column is-half">
                      <div className="media special">
                        <div className="media-content">
                          <div class="card-image">
                            <figure class="image is-5by3">
                              <img src={withPrefix('/img/messe-mockup.png')} alt="Messen Beispiele" />
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="partners">
            <div class="container noanimate">
              <div className="columns">
                <div className="column is-full logos">
                  <div className="columns lower">
                    <div className="column is-one-fifth logo"><img src={withPrefix('/img/kuka-neu.svg')} alt="Logo" /></div>
                    <div className="column is-one-fifth logo"><img src={withPrefix('/img/hauser_tinted.svg')} alt="Logo" /></div>
                    <div className="column is-one-fifth logo"><img src={withPrefix('/img/anton_paar_tinted.svg')} alt="Logo" /></div>
                    <div className="column is-one-fifth logo"><img src={withPrefix('/img/erema_tinted.svg')} alt="Logo" /></div>
                    <div className="column is-one-fifth logo"><img src={withPrefix('/img/haidlmair_tinted.svg')} alt="Logo" /></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
      <section className="videoblock">
        <div className="container">
          <div className="columns">
            <div className="column is-2"></div>
            <div className="video column is-8">
              <div className="card">
                <div className="card-image">
                  <figure className="image is-16by9">
                    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/GaGBgfVCRwo?autoplay=1&mute=1" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                  </figure>
                </div>
              </div>
            </div>
            <div className="column is-2"></div>
          </div>
        </div>
      </section>
      <section className="headliner alt">
        <Element name="node2" />
        <div className="container">
          <div className="column">
            <h2>Unsere <strong>Angebote</strong></h2>
            <p>
            </p>
          </div>
        </div>
      </section>
      <section className="pricing messe">
        <section className="plans features">
          <section className="features-teaser">
            <div className="container special-bg">
              <div className="columns tiers align-helper">
                <div className="tile is-parent is-4">
                  <div className="inner">
                    <div className="top teal2">
                      <p className="subliner">
                        Plus
                      </p>
                      <p className="title">
                      </p>
                      <p className="info">
                        Zum einfachen Einstieg für
                        einzelne Anwendungen und kleine Messen
                      </p>
                    </div>

                  </div>
                </div>
                <div className="tile is-parent is-4">
                  <div className="inner">
                    <div className="top teal5">
                      <p className="subliner">
                      Pro
                      </p>
                      <p className="title">
                      </p>
                      <p className="info">
                      Umfassende Lösung für viele Messe-Einsätze, unterschiedliche Stationen

                      </p>
                    </div>

                  </div>
                </div>
                <div className="tile is-parent is-4 enterprise">
                  <div className="inner">
                    <div className="top teal3">
                      <p className="subliner">
                      Individual
                      </p>
                      <p className="info">
                      Individuelle Designs und auf Sie abgestimmte Nutzungsmöglichkeiten
                      </p>
                    </div>

                  </div>
                </div>
              </div>
              <div className="pricing-info">
              </div>
              <div className="partners messe">
                <Link to={ props.locale === "en" ? "/contact" : "/de/contact" } className="messe alt button is-rounded customers-button">Jetzt anfragen</Link>
              </div>
            </div>
          </section>
        </section>
      </section>
      <section className="headliner alt">
        <Element name="node3" />
        <div className="container">
          <div className="column">
            <h2>Einfacher und unkomplizierter <strong>Ablauf</strong></h2>
            <p>
            </p>
          </div>
        </div>
      </section>
      <section className="fancylist">
        <div className="columns">
          <div className="column is-full mask">
            <p>
            <strong>Beratung und Kick-off</strong><br/>
            Wenn Sie sich entschieden haben, folgt ein Kick-off, bei dem wir Ihre Anforderungen erheben, den Ablauf mit Ihnen nochmals festlegen, To-dos definieren und die zeitlichen Rahmenbedingungen festhalten.
            </p>
            <p>
            <strong>Auswahl Template-Set Basis</strong><br/>
            Sie entscheiden sich aus aktuell mehr als 20 Vorlagen für eine Grundrichtung auf der Ihre Messe-Präsentation bzw. Messe-App basieren soll.
            </p>
            <p>
            <strong>Corporate Design und Vorgaben bereitstellen</strong><br/>
            Unsere Designer sichten die Vorgaben, Ihr Corporate Design und die später genutzten Inhalte.
            </p>
            <p>
            <strong>Erstellung der Vorlagen</strong><br/>
            Auf dieser Basis wird das gewählte Template-Set auf Ihr Branding angepasst und für Ihre Nutzung aufbereitet. Hierbei ist eine Feedback-Schleife inkludiert, um Ihre Rückmeldungen einfließen zu lassen.
            </p>
            <p>
            <strong>Schulung</strong><br/>
            Anschließend schulen wir die verantwortlichen Personen bzw. Anwender in der Nutzung des Tools und stellen alle notwendigen Informationen für eine erfolgreiche Verwaltung, Befüllung und Präsentation zur Verfügung.
            </p>
            <p>
            <strong>Befüllung und Nutzung</strong><br/>
            Nun können Sie selbstständig in presono arbeiten und die erstellte Vorlage mit Ihren Inhalten befüllen bzw. Ihre Inhalte mit den zur Verfügung gestellten Apps nutzen. Darüber hinaus können Sie dieses Grundgerüst natürlich auch selbst ausbauen und erweitern.
            </p>
            <p>
            <strong>Auf Ihrem Messestand beeindrucken</strong><br/>
            </p>
          </div>
        </div>
      </section>
      <section className="customers">
        <div className="container">
          <div className="columns">
            <div className="column is-full">
              <div className="columns logo-inner">
                <div className="logo-slider">
                  <div className="logos" width={ 1200 / 5 * 31 + "px"}>
                    <div className="logo"><img src={withPrefix('/img/gpi_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/hauser_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/keba_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/miba_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/kuka-neu.svg')} alt="Logo" /></div>

                    <div className="logo"><img src={withPrefix('/img/intersport_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/haidlmair_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/erema_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/andmetics_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/anton_paar_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/Brucha_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/gmundner_keramik_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/grosarl_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/magenta_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/Wings_for_life_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/eat_happy_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/green_edge_cloud_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/nachrichten_at_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/Alpla_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/CADS.Additive_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/stadt_linz_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/welser_profile_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_caritas.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_helvetia.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_hlw_steyr.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_infoniqa.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_lsz.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_magenta.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_mm.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_mohrenwirt.png')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/logo_prefa.png')} alt="Logo" /></div>

                    <div className="logo"><img src={withPrefix('/img/gpi_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/hauser_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/keba_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/miba_tinted.svg')} alt="Logo" /></div>
                    <div className="logo"><img src={withPrefix('/img/kuka-neu.svg')} alt="Logo" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="headliner partners starfield b3">
        <Element name="node4" />
        <div className="container">
          <div className="column">
            <p className="smalltext">
            presono findet bereits breite Anwendung in unterschiedlichen Branchen und auf unterschiedlichen Messen. Unter anderem wurde unsere Lösung etwa auf der K, Hannover Messe für Industrie, EuroShop, GIFA, Braubeviale, Hohe Jagd und vielen weiteren Messen eingesetzt.
            </p>
            <Link to={ props.locale === "en" ? "/contact" : "/de/contact" } className="messe button is-rounded customers-button">Jetzt Kunde werden</Link>
          </div>
        </div>
      </section>
      <Newsletter newsletter={data.frontmatter} locale="de" />
      <Footer locale={locale} />
    </Layout>
  )
}

export default MessePage;

MessePage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query MessePageContent($locale: String) {
    MessePageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_apps"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }
}
`
